import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { useNotification } from '@/contexts/NotificationContext';
import { copyToClipboard } from './copyToClipboard';

interface CopyableTextProps {
  /** Значение, которое копируется в буфер обмена. */
  value: string;
  /** Если задано — показывается вместо `value`; копируется по-прежнему `value`. */
  displayValue?: string;
  copiedMessage?: string;
  tooltip?: string;
  typographySx?: Record<string, unknown>;
}

const CopyableText: React.FC<CopyableTextProps> = ({
  value,
  displayValue,
  copiedMessage = 'Скопировано',
  tooltip = 'Копировать',
  typographySx,
}) => {
  const { showNotification } = useNotification();

  const handleCopy = async () => {
    try {
      await copyToClipboard(value);
      showNotification(copiedMessage, 'success');
    } catch (error) {
      showNotification('Не удалось скопировать', 'error');
    }
  };

  return (
    <Tooltip title={tooltip}>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
          maxWidth: '100%',
        }}
        onClick={handleCopy}
      >
        <Box
          component="span"
          sx={{
            display: 'inline-block',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.5,
            ...typographySx,
          }}
        >
          {displayValue ?? value}
        </Box>
        <IconButton
          size="small"
          aria-label={tooltip}
          onClick={(event) => {
            event.stopPropagation();
            handleCopy();
          }}
        >
          <CopyIcon fontSize="small" />
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default CopyableText;
